/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './disable-sensors.scss';

/* eslint-disable import/no-unresolved, import/default */

import disableSensorsTemplate from './disable-sensors.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.disableSensorsTable', [])
    .directive('agDisableSensorsTable', DisableSensorsTable)
    .name;

/*@ngInject*/
function DisableSensorsTable() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            sensorLines: '=',
            enabledSensorsAttr: '=',
            allowEdit: '<',
            onEnabledSensorsUpdated: '&'
        },
        controller: DisableSensorsTableController,
        controllerAs: 'vm',
        templateUrl: disableSensorsTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function DisableSensorsTableController($scope, $element, $translate, $filter) {

    let vm = this;
    vm.sensorsLoading = true
    vm.tempStatCablesLoading = true;

    vm.disableSensorsTableBody = null;
    vm.disableSensorsTableHeader = null;

    vm.disableSensorsTableWidth = disableSensorsTableWidth;

    vm.sensorCableEnabled = sensorCableEnabled;
    vm.toggleSensorCableEnable = toggleSensorCableEnable;
    vm.isSensorReadonly = isSensorReadonly;

    $scope.disableSensorsTableInitWatch = $scope.$watch(function() {
        return angular.element('md-list.ag-disable-sensors-table', $element).length;
    }, function (length) {
        if (length) {
            $scope.disableSensorsTableInitWatch();
            var disableSensorsTable = angular.element('md-list.ag-disable-sensors-table', $element);
            vm.disableSensorsTableHeader = angular.element('.ag-header-wrapper', disableSensorsTable);
            vm.disableSensorsTableBody = angular.element('#disable-sensors-table-body', disableSensorsTable);
            vm.disableSensorsTableHeader.css({width: 'auto'});
            vm.disableSensorsTableBody.scroll(function() {
                var width = vm.disableSensorsTableBody.width() + vm.disableSensorsTableBody[0].scrollLeft + 'px';
                var left = -vm.disableSensorsTableBody[0].scrollLeft + 'px';
                vm.disableSensorsTableHeader.css({
                    left: left,
                    width: width
                });
            });
        }
    });

    $scope.$watchGroup(['vm.sensorLines', 'vm.enabledSensorsAttr'], function() {
        if (vm.sensorLines) {
            reset();
            vm.sensorsLoading = true;

            for (var i=0;i<vm.sensorLines.length;i++) {
                var sensorLine = vm.sensorLines[i];
                vm.maxSensorsCount = Math.max(vm.maxSensorsCount, sensorLine.sensorCount);
            }

            if (!vm.enabledSensorsAttr) {
                vm.enabledSensors = createDefaultEnabledSensors();
            } else {
                vm.enabledSensors = angular.fromJson(vm.enabledSensorsAttr);
                if (!vm.enabledSensors.enabledSensorCables) {
                    vm.enabledSensors.enabledSensorCables = [];
                    for (i=0;i<vm.sensorLines.length;i++) {
                        vm.enabledSensors.enabledSensorCables.push(vm.sensorLines[i].id.id);
                    }
                }
                if (angular.isUndefined(vm.enabledSensors.maxEnabledSensorId)) {
                    vm.enabledSensors.maxEnabledSensorId = vm.maxSensorsCount;
                }
                for (var col=0;col<vm.sensorLines.length;col++) {
                    sensorLine = vm.sensorLines[col];
                    if (!vm.enabledSensors[sensorLine.id.id]) {
                        vm.enabledSensors[sensorLine.id.id] = [];
                        vm.enabledSensors.enabledSensorCables.push(sensorLine.id.id);
                        for (var sensorId=0;sensorId<sensorLine.sensorCount;sensorId++) {
                            vm.enabledSensors[sensorLine.id.id].push(sensorId);
                        }
                    }
                }
                for (var sensorLineId in vm.enabledSensors) {
                    if (sensorLineId === 'enabledSensorCables' || sensorLineId === 'maxEnabledSensorId') {
                        continue;
                    }
                    var result = $filter('filter')(vm.sensorLines, {id: {id: sensorLineId }}, true);
                    if (!result || !result.length) {
                        delete vm.enabledSensors[sensorLineId];
                        var index = vm.enabledSensors.enabledSensorCables.indexOf(sensorLineId);
                        if (index > -1) {
                            vm.enabledSensors.enabledSensorCables.splice(index, 1);
                        }
                    }
                }
            }

            for (var row=vm.maxSensorsCount-1;row>=0;row--) {
                var sensorRow = {
                    sensorName: $translate.instant('ag.silo.sensor') + ' ' + (row + 1),
                    data: []
                };
                for (col=0;col<vm.sensorLines.length;col++) {
                    sensorLine = vm.sensorLines[col];
                    var enabled = false;
                    if (vm.enabledSensors[sensorLine.id.id]) {
                        var enabledLineSensors = vm.enabledSensors[sensorLine.id.id];
                        enabled = enabledLineSensors.indexOf(row) > -1;
                    }
                    var sensorData = {
                        sensorLineId: sensorLine.id.id,
                        sensorId: row,
                        hasSensor: row < sensorLine.sensorCount,
                        enabled: enabled
                    };
                    sensorRow.data.push(sensorData);
                }
                vm.sensorsData.push(sensorRow);
            }
            vm.sensorsLoading = false;
            $scope.$applyAsync(()=>{
                vm.maxEnabledSensorId = vm.enabledSensors.maxEnabledSensorId;
                startWatchEnabledSensors();
            });
        }
    });

    function sensorCableEnabled(cable) {
        return vm.enabledSensors.enabledSensorCables.indexOf(cable.id.id) > -1;
    }

    function toggleSensorCableEnable(cable, col) {
        var index = vm.enabledSensors.enabledSensorCables.indexOf(cable.id.id);
        if (index > -1) {
            vm.enabledSensors.enabledSensorCables.splice(index, 1);
            vm.sensorsData.forEach((sensorRow) => {
                sensorRow.data[col].enabled = false;
            });
        } else {
            vm.enabledSensors.enabledSensorCables.push(cable.id.id);
            for (var row = vm.maxSensorsCount-1; row >= vm.maxSensorsCount - vm.maxEnabledSensorId; row--) {
                var sensorRow = vm.sensorsData[row];
                sensorRow.data[col].enabled = true;
            }
        }
    }

    function isSensorReadonly(row, col) {
        var cable = vm.sensorLines[col];
        if (!sensorCableEnabled(cable)) {
            return true;
        } else if (vm.maxSensorsCount - row - 1 >= vm.maxEnabledSensorId) {
            return true;
        }
        return false;
    }

    function createDefaultEnabledSensors() {
        var enabledSensors = {};
        enabledSensors.enabledSensorCables = [];
        enabledSensors.maxEnabledSensorId = vm.maxSensorsCount;
        for (var col=0;col<vm.sensorLines.length;col++) {
            var sensorLine = vm.sensorLines[col];
            enabledSensors[sensorLine.id.id] = [];
            enabledSensors.enabledSensorCables.push(sensorLine.id.id);
            for (var sensorId=0;sensorId<sensorLine.sensorCount;sensorId++) {
                enabledSensors[sensorLine.id.id].push(sensorId);
            }
        }
        return enabledSensors;
    }

    function startWatchEnabledSensors() {
        vm.watchEnabledSensorsPromise =
            $scope.$watch('vm.sensorsData', (newVal, prevVal) => {
                if (angular.equals(newVal, prevVal)) {
                    return;
                }
                enabledSensorsUpdated();
            }, true);
        vm.watchEnabledSensorCablesPromise =
            $scope.$watch('vm.enabledSensors.enabledSensorCables', (newVal, prevVal) => {
                if (angular.equals(newVal, prevVal)) {
                    return;
                }
                enabledSensorsUpdated();
            }, true);
        vm.watchMaxEnabledSensorIdPromise =
            $scope.$watch('vm.maxEnabledSensorId', (newVal, prevVal) => {
                if (angular.equals(newVal, prevVal)) {
                    return;
                }
                stopWatchEnabledSensors();
                var startIndex;
                var endIndex;
                var enabled;
                if (newVal > prevVal) {
                    enabled = true;
                    startIndex = vm.maxSensorsCount - newVal;
                    endIndex = vm.maxSensorsCount - prevVal - 1;
                } else {
                    enabled = false;
                    startIndex = vm.maxSensorsCount - prevVal;
                    endIndex = vm.maxSensorsCount - newVal - 1;
                }
                for (var row = startIndex; row <= endIndex; row++) {
                    var sensorRow = vm.sensorsData[row];
                    for (var col = 0; col < sensorRow.data.length; col++) {
                        sensorRow.data[col].enabled = enabled && !isSensorReadonly(row, col) ? true : false;
                    }
                }
                enabledSensorsUpdated();

                startWatchEnabledSensors();
            }, true);
    }

    function stopWatchEnabledSensors() {
        if (vm.watchEnabledSensorsPromise) {
            vm.watchEnabledSensorsPromise();
            vm.watchEnabledSensorsPromise = null;
        }
        if (vm.watchEnabledSensorCablesPromise) {
            vm.watchEnabledSensorCablesPromise();
            vm.watchEnabledSensorCablesPromise = null;
        }
        if (vm.watchMaxEnabledSensorIdPromise) {
            vm.watchMaxEnabledSensorIdPromise();
            vm.watchMaxEnabledSensorIdPromise = null;
        }
    }

    function enabledSensorsUpdated() {
        var enabledSensors = {};
        for (var col=0;col<vm.sensorLines.length;col++) {
            var sensorLine = vm.sensorLines[col];
            enabledSensors[sensorLine.id.id] = [];
        }
        for (var row=vm.sensorsData.length-1;row>=0;row--) {
            var sensorRow = vm.sensorsData[row];
            for (col=0;col<sensorRow.data.length;col++) {
                var sensorData = sensorRow.data[col];
                if (sensorData.hasSensor && sensorData.enabled) {
                    enabledSensors[sensorData.sensorLineId].push(sensorData.sensorId);
                }
            }
        }
        enabledSensors.enabledSensorCables = vm.enabledSensors.enabledSensorCables;
        enabledSensors.maxEnabledSensorId = vm.maxEnabledSensorId;

        if (vm.onEnabledSensorsUpdated) {
            vm.onEnabledSensorsUpdated({enabledSensors: enabledSensors});
        }
    }


    $scope.$on('$destroy', function() {
        reset();
    });

    function reset() {
        stopWatchEnabledSensors();
        vm.enabledSensors = null;
        vm.maxSensorsCount = 0;
        vm.maxEnabledSensorId = 0;
        vm.sensorsData = [];
        if (vm.disableSensorsTableHeader) {
            vm.disableSensorsTableHeader.css({width: 'auto'});
        }
    }

    function disableSensorsTableWidth() {
        var hasScroll = false;
        if (vm.disableSensorsTableBody) {
            hasScroll = vm.disableSensorsTableBody[0].scrollHeight > vm.disableSensorsTableBody[0].clientHeight;
        }
        var result = 16 + 70 + (vm.sensorLines ? vm.sensorLines.length : 0) * 30;
        if (hasScroll) {
            result += 15;
        }
        return result;
    }

}